import "../styles/Contacto.css";

const Contacto = () => {
  return (
    <>
      <div className="home p-0">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-image p-0">
              <div
                className="contacto__image-container"
                style={{ background: "white" }}
              >
                <img
                  src="/assets/img/homeout/img-contacto.png"
                  className="home__image_contact"
                  alt=""
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-back div__contacto">
              <div className="d-block d-lg-none">
                <h1 className="titulo__contacto">Contáctanos</h1>
              </div>
              <div className="home__text-container container__contacto">
                <div className="card__contacto-item">
                  <div className="card__contacto-img d-none d-lg-block">
                    <img
                      src="/assets/img/homeout/contacto/ico-fono.svg"
                      alt="icono_telefono"
                      className="d-none d-lg-block"
                    />
                  </div>
                  <div className="div__telefono">
                    <p className="card__contacto-description">
                      Si tienes alguna inquietud o consulta, comunícate con
                      nosotros en nuestra línea de atención en:
                    </p>
                    <div className="d-lg-none d-block">
                      <br />
                    </div>
                    <p
                      className="card__contacto-description container__contacto__tel-mail"
                      style={{
                        color: "var(--rojo)",
                        fontFamily: "var(--fuente-bold)",
                      }}
                    >
                      Línea de atención Cardif:{" "}
                      <a
                        href="tel:8005220973"
                        style={{
                          color: "var(--rojo)",
                          fontFamily: "var(--fuente-bold)",
                        }}
                      >
                        <div className="d-lg-none d-block"></div>800 522 0973
                      </a>
                      <br />
                      <div className="breakLine"></div>Horarios de atención:{" "}
                      <div className="d-lg-none d-block"></div>Lunes a viernes{" "}
                      <div className="d-lg-none d-block"></div>de 08:00 a 21:00
                      hrs
                    </p>
                  </div>
                </div>
                <div className="card__contacto-item">
                  <div className="card__contacto-img d-none d-lg-block">
                    <img
                      src="/assets/img/homeout/contacto/ico-correo.svg"
                      alt="icono_correo"
                      className="d-none d-lg-block"
                    />
                  </div>
                  <div>
                    <p className="card__contacto-description">
                      También puedes escribirnos a nuestro correo electrónico:
                    </p>
                    <p
                      className="card__contacto-description"
                      style={{
                        color: "var(--rojo)",
                        fontFamily: "var(--fuente-bold)",
                        paddingTop: "1rem",
                      }}
                    >
                      <a
                        href="mailto:middleoffice@cardif.com.mx"
                        style={{
                          color: "var(--rojo)",
                          fontFamily: "var(--fuente-bold)",
                        }}
                      >
                        middleoffice@cardif.com.mx
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacto;
